import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// types
import { AuthProps, Notification } from 'types/auth';
import { chat } from './chat';
import axiosServices from 'utils/axios';
const url = process.env.REACT_APP_API_URL + '/api/user/v1';
// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// ==============================|| SLICE - AUTH ||============================== //

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRegister(state, action: PayloadAction<{ user: AuthProps['user'] }>) {
      state.user = action.payload.user;
    },
    setLogin(state, action: PayloadAction<{ user: AuthProps['user'] }>) {
      if (!action.payload.user?._id) {
        return;
      }
      state.isLoggedIn = true;
      state.isInitialized = true;
      state.user = {
        ...action.payload.user,
        settings: {
          notification: {
            ...action.payload.user?.settings?.notification,
            inAttendanceMail: action.payload.user?.settings?.notification?.inAttendanceMail ?? false,
            inAttendancePopup: action.payload.user?.settings?.notification?.inAttendancePopup ?? false,
            inAttendanceSound: action.payload.user?.settings?.notification?.inAttendanceSound ?? false,
            waitingAttendanceMail: action.payload.user?.settings?.notification?.waitingAttendanceMail ?? false,
            waitingAttendancePopup: action.payload.user?.settings?.notification?.waitingAttendancePopup ?? false,
            waitingAttendanceSound: action.payload.user?.settings?.notification?.waitingAttendanceSound ?? false
          }
        }
      };
    },
    setLogout(state) {
      state.isInitialized = true;
      state.isLoggedIn = false;
      state.user = null;
    },
    updateNotificationSettingsAuth(state, action: PayloadAction<Notification>) {
      if (state.user) {
        state.user.settings = { notification: action.payload };
      }
    },
    setNotificationNoticeSeenAt(state, action: PayloadAction<string | null>) {
      if (state.user) {
        state.user.notificationNoticeSeenAt = action.payload;
      }
    }
  }
});

export default auth.reducer;

export function getLoggedUsers() {
  return async (dispatch: any) => {
    try {
      const response = await axiosServices.get(`${url}/logged-users`);
      if (response.data?.settings?.notification) {
        dispatch(auth.actions.updateNotificationSettingsAuth(response.data.settings.notification));
      } else {
        dispatch(
          auth.actions.updateNotificationSettingsAuth({
            inAttendanceMail: false,
            inAttendancePopup: false,
            inAttendanceSound: false,
            waitingAttendanceMail: false,
            waitingAttendancePopup: false,
            waitingAttendanceSound: false
          })
        );
      }
      dispatch(auth.actions.setNotificationNoticeSeenAt(response.data?.notificationNoticeSeenAt ?? null));
    } catch (error: any) {
      if (error && typeof error === 'object' && 'response' in error && error.response?.status === 502) {
        window.location.replace('/maintenance/error/500');
      } else {
        dispatch(chat.actions.hasError(error instanceof Error ? error.message : 'Erro ao buscar usuários logados'));
      }
    }
  };
}

export const { setRegister, setLogin, setLogout, updateNotificationSettingsAuth, setNotificationNoticeSeenAt } =
  auth.actions;
